import { TableCell, Box, Button, Dialog, DialogTitle, IconButton, DialogContent, Typography } from "@mui/material";
import { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';

export const DetailsCell = ({ details }) => {
  const [open, setOpen] = useState(false);
  const TRUNCATION_LIMIT = 100; // Shorter limit for details column
  
  // Stop event propagation and open the modal
  const handleOpen = (e) => {
    // Prevent the click from triggering any potential parent handlers 
    if (e && e.stopPropagation) {
      e.stopPropagation();
    }
    setOpen(true);
  };
  
  const handleClose = () => setOpen(false);

  // Handle null/undefined details
  if (!details) {
    return (
      <TableCell sx={{ py: 1, fontSize: "0.95rem" }}>
        <Typography variant="body2" color="text.secondary">
          No details
        </Typography>
      </TableCell>
    );
  }

  // Determine if the details should be truncated
  const isTruncated = details.length > TRUNCATION_LIMIT;
  
  // Prepare the text to display in the cell
  const displayText = isTruncated
    ? details.substring(0, TRUNCATION_LIMIT).trim()
    : details;

  return (
    <TableCell sx={{ py: 1, fontSize: "0.95rem" }}>
      <Box
        component="span"
        sx={{
          whiteSpace: 'pre-wrap', 
          display: 'block',
          fontSize: '0.95rem' 
        }}
      >
        {displayText}
        {isTruncated && '...'}
        
        {isTruncated && (
          <Button
            variant="text"
            size="small"
            onClick={handleOpen}
            sx={{
              p: 0,
              minWidth: 0,
              ml: 1,
              textTransform: 'none',
              fontWeight: 'bold',
              fontSize: '0.875rem',
              color: 'primary.main'
            }}
          >
            Show More
          </Button>
        )}
      </Box>

      <Dialog
        onClose={handleClose} 
        open={open}
        maxWidth="md"
        fullWidth
        sx={{
          '& .MuiDialog-paper': {
            borderRadius: '12px',
          }
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2, fontWeight: 'bold', fontSize: '1.25rem', borderBottom: '1px solid #eee' }}>
          Audit Log Details Full View
          <IconButton
            aria-label="close"
            onClick={handleClose} 
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 3 }}>
          <Typography variant="body1" component="pre" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.6, fontSize: '0.95rem' }}>
            {details}
          </Typography>
        </DialogContent>
      </Dialog>
    </TableCell>
  );
};